import React, {createContext, useContext, useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {io} from 'socket.io-client'
import {getUserData} from '../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import {ENV} from './_helpers/EnvHelper'

const SocketContext = createContext(null)

export const SocketProvider = ({children}: any) => {
  const ENDPOINT: any = ENV().REACT_APP_DOMAIN_SOCKETID
  const user = useSelector(getUserData)
  const Admin = useSelector((state: any) => state?.AdminAuth?.adminData?.data?.user)
  const [socket, setSocket] = useState<any>(null)

  useEffect(() => {
    // Create the socket instance

    if (user?.user?._id !== undefined || Admin?._id !== undefined) {
      const newSocket = io(ENDPOINT, {
        path: '/notifications',
        transports: ['polling'],
        query: {
          userId: user?.user?._id || Admin?._id,
        },
      })
      console.log(newSocket, 'newSocket')

      // Set the socket instance in the state
      setSocket(newSocket)
    }

    // Clean up the socket on component unmount
  }, [user?.user?._id, Admin?._id])

  return <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
}

export const useSocket = () => {
  const socket = useContext(SocketContext)
  //   if (!socket) {
  //     throw new Error('useSocket must be used within a SocketProvider')
  //   }
  return socket
}
